import { call } from "@saas/api-client";
import { Badge, Card, DescriptionList, ErrorAlert, Loading, PageHeader, Table, useAsync } from "@saas/ui";
import { api } from "./api";

export function IdentityPage() {
  const setup = useAsync(() => call(api.GET("/api/identity-provider-setup")), []);
  if (setup.loading && !setup.data) return <Loading />;
  return (
    <>
      <PageHeader
        title="Identity provider"
        description="Read-only view of how your administrators and users sign in. Membership in this app decides the role; the identity provider only proves who someone is."
      />
      <ErrorAlert error={setup.error} />
      {setup.data && (
        <>
          <Card title="Token claims">
            <DescriptionList
              items={[
                ["Tenant id", <code key="t">{setup.data.tenantId}</code>],
                ["Tenant claim", <code key="tc">{setup.data.tenantClaim}</code>],
                ["Role claim", <code key="rc">{setup.data.roleClaim}</code>],
              ]}
            />
          </Card>
          {setup.data.realms.map((realm) => (
            <Card key={realm.realm} title={`${realm.audience} (realm “${realm.realm}”)`}>
              <DescriptionList
                items={[
                  ["Issuer", <code key="i">{realm.issuer}</code>],
                  ["Sign-in page", <a key="s" href={realm.signInUrl}>{realm.signInUrl}</a>],
                ]}
              />
              <Table caption="Sign-in methods" headers={["Method", "Type", "Status"]}>
                {realm.providers.map((p) => (
                  <tr key={p.alias}>
                    <td>{p.displayName}</td>
                    <td>
                      <code>{p.type}</code>
                    </td>
                    <td>{p.enabled ? <Badge tone="success">Enabled</Badge> : <Badge tone="neutral">Not configured</Badge>}</td>
                  </tr>
                ))}
              </Table>
            </Card>
          ))}
        </>
      )}
    </>
  );
}
